module.exports = __webpack_public_path__ + "static/img/footer-menu-icon03.6aaed783.svg";